<template>
  <layout-content :title="title">
    <template slot="header">
      {{ $t(`${$route.meta.title['code']}`, { name: title }) }}
    </template>
    <template slot="top-filter">
      <tooltip
        style="width: 100%"
        min-width="300"
        max-width="300"
        placement="top"
        theme="light"
        :transfer="true"
        :content="$t('autocaller_v2.monitoring_general.tooltip.index')"
      >
        <select-id v-model="filter.campaign_id" :only_active="true" :clearable="false" />
      </tooltip>
    </template>
    <table-component v-if="campaign.id" :single="true" :campaign="campaign" />
  </layout-content>
</template>
<script>
  import SelectId from '@autocaller_v2/components/campaigns-filter-id.vue';
  import TableComponent from '@autocaller_v2/components/monitoring/monitoring-table.vue';
  import { CampaignsService } from '@autocaller_v2/services/CampaignsService';

  export default {
    components: {
      SelectId,
      TableComponent
    },
    data() {
      return {
        filter: {
          campaign_id: null
        },
        title: '',
        campaign: {}
      };
    },
    watch: {
      'filter.campaign_id': {
        handler: function (new_id) {
          this.getCampaign(new_id);
        },
        immediate: true,
        deep: true
      }
    },
    methods: {
      getCampaign(id) {
        id &&
          CampaignsService.getItem(id).then((response) => {
            this.campaign = response || {};
            this.title = response.name;
          });
      }
    }
  };
</script>
